import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/css'
import { IconStats } from '@contrast-security-inc/design-system-foundations'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'

export interface ChartToggleProps {
  readonly onClick: () => void
}

export const ChartToggle = ({ onClick }: ChartToggleProps) => {
  return (
    <Tooltip body={<FormattedMessage id="action_viewTimeline" />}>
      <div
        className={css`
          margin: 5px 0px 5px 8px;
          cursor: pointer;
        `}
        data-testid="img_chart_toggle"
        onClick={onClick}
      >
        <IconStats />
      </div>
    </Tooltip>
  )
}
